<div class="container">
    <div class="header-container">
        <div class="header-container">
            <div class="loading" *ngIf="loading">
                <div class="loader"></div>
            </div>
        </div>
    </div>
    <div>
        <div class="content">
            <div class="row margin-top-8">
                <div class="col-md-4"><h4>Manage Recommendation / Advice</h4></div>
            </div>


            <div class="row margin-top-8">
                <div class="col-md-4 label" [ngClass]="{'red': !advice.bikeTypeID || advice.bikeTypeID===0}">Select a
                    Bike Type:
                </div>
                <div class="col-md-5">
                    <div class="p-inputgroup">
                        <p-dropdown [options]="bikeTypes" [(ngModel)]="advice.bikeTypeID"
                                    placeholder="Select a bike type" (onChange)="getGearTypes(advice.bikeTypeID)">
                            <ng-template let-biketype pTemplate="biketype">
                                <span style="margin-left:.25em">{{biketype.label}}</span>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label" [ngClass]="{'red': !advice.gearTypeID || advice.gearTypeID===0}">Select a
                    Gear Type:
                </div>
                <div class="col-md-5">
                    <div class="p-inputgroup">
                        <p-dropdown [options]="gearTypes" [(ngModel)]="advice.gearTypeID"
                                    placeholder="Select a gear type">
                            <ng-template let-geartype pTemplate="geartype">
                                <span style="margin-left:.25em">{{geartype.label}}</span>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label">Select a language for the recommendation / advice:</div>
                <div class="col-md-5">
                    <div class="p-inputgroup">
                        <p-dropdown [options]="languages" [(ngModel)]="advice.languageCode"
                                    placeholder="Select a language for the advice">
                            <ng-template let-language pTemplate="language">
                                <span style="margin-left:.25em">{{language.label}}</span>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label">Select other bike types this is also useful for:</div>
                <div class="col-md-5">
                    <p-multiSelect [options]="otherBikeTypes()" [showToggleAll]="false" [filter]="false"
                                   [(ngModel)]="advice.otherBikeTypes" placeholder="">
                        <ng-template let-biketype pTemplate="biketype">
                            <span style="margin-left:.25em">{{biketype.label}}</span>
                        </ng-template>
                    </p-multiSelect>
                </div>
            </div>

            <hr>
            <div class="row margin-top-8">
                <div class="col-md-4"><h4>Recommendation</h4></div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label">Recommendation Active:</div>
                <div class="col-md-5">
                    <div class="p-inputgroup">
                        <p-inputSwitch [(ngModel)]="advice.recommendationActive"></p-inputSwitch>
                    </div>
                </div>
            </div>
            <div class="row margin-top-8">
                <div class="col-md-4 label"
                     [ngClass]="{'red': advice.recommendationActive && advice.basicRecommendation.length===0}">Basic
                    Recommendation:
                </div>
                <div class="col-md-5">
                    <div class="p-inputgroup">
                        <input type="text" pInputText
                               placeholder="This will be the basic recommendation the user will see whan adding a new component."
                               [(ngModel)]="advice.basicRecommendation"/>
                    </div>
                </div>
            </div>

            <hr>
            <div class="row margin-top-8">
                <div class="col-md-4"><h4>Advice</h4></div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label">Advice Active:</div>
                <div class="col-md-5">
                    <div class="p-inputgroup">
                        <p-inputSwitch [(ngModel)]="advice.adviceActive"></p-inputSwitch>
                    </div>
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label" style="margin-top:0"
                     [ngClass]="{'red': advice.adviceActive && headerImageURL.length===0}">Advice Image Header:
                </div>
                <div class="col-md-5">
                    <div class="header-image"><img [src]="headerImageURL"
                                                   *ngIf="headerImageURL!==null && headerImageURL.length>0"/>
                        <div class="margin-top-8">
                            <button pButton type="button" class="p-button accent full-width"
                                    label="Upload Header Image" (click)="fileUpload.click()"></button>
                            <input #fileUpload type="file" style="display: none" (change)="myUploader($event)">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label" [ngClass]="{'red': advice.adviceActive && advice.title.length===0}">Advice
                    Title:
                </div>
                <div class="col-md-5">
                    <div class="p-inputgroup">
                        <input type="text" pInputText
                               placeholder="Advice title will appear in the app as the main label for the advice linked to the gear"
                               [(ngModel)]="advice.title"/>
                    </div>
                </div>
            </div>

            <div class="row margin-top-8">
                <div class="col-md-4 label" style="margin-top:0"
                     [ngClass]="{'red': advice.adviceActive && advice.content.length===0}">Content:
                </div>
                <div class="col-md-5">
                    <div>
                        <div>
                            <angular-editor #contentEditor [(ngModel)]="advice.content"
                                            [config]="editorConfig"></angular-editor>
                            <span class="fa fa-youtube"
                                  style="position: absolute; top: 8px;right: 46px;font-size: 20px;color: #dc3545; cursor: pointer;"
                                  (click)="insertVideo()"></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row margin-top-16">
                <div class="col-md-5"></div>
                <div class="col-md-2">
                    <button pButton type="button" class="p-button-raised full-width"
                            label="{{saving ? 'Please Wait' : 'Delete Advice'}}"
                            (click)="DeleteAdvice()" *ngIf="advice.id>0"
                            [disabled]="saving || loading"></button>
                </div>
                <div class="col-md-2">
                    <button pButton type="button" class="p-button-raised approve full-width"
                            label="{{saving ? 'Please Wait' : 'Save Changes'}}"
                            (click)="SaveAdvice()"
                            [disabled]="saving || loading || !valid()"></button>
                </div>
            </div>


        </div>
    </div>
</div>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
